$('#gform_wrapper_2 .gfield--input-type-text, .gform_wrapper .gfield--input-type-email, .gform_wrapper .gfield--input-type-number').each(function() {
    // $(this).find('.gform-field-label').addClass('sr-only');
});

$('#gform_wrapper_2 .gfield--type-consent').each(function() {
    $(this).find('legend').addClass('sr-only');
});
